'use strict';

var _ = require('lodash');
var GridDrawerController = function GridDrawerController($scope, $log, configurationLoaderService, commentsService, mappedRulesService, featureToggleService, directForecastingConfigurationService, configurationService) {
  $scope.selectedRow = null;
  $scope.selectedRows = [];
  $scope.selectedMode = true;
  $scope.containsMenuItems = true;
  $scope.isPanelVisible = false;
  $scope.isDrawerVisible = false;
  $scope.reopenDrawerFlag = false;
  $scope.reopenDrawerMode = false;
  $scope.commentsCount = 0;
  $scope.rulesCount = 0;
  $scope.selectionValidationFunctions = {};
  $scope.selectionValidationFunctions['service-share'] = function (selectedRows) {
    var result = _.uniqBy(selectedRows, 'market');
    return result.length === 1;
  };
  $scope.selectionValidationFunctions['bid-price'] = function (selectedRows) {
    return !(selectedRows[0] && selectedRows[0].isDiscontinued === 'Yes');
  };
  var menu = {};
  var defaultMenu = !_.isUndefined($scope.dynamicGridSettings) ? $scope.dynamicGridSettings.drawerMenu : configurationLoaderService.getGridDrawerSettings($scope.gridId).drawerMenu;
  var MENU_BUTTON_HEIGHT = 40;
  $scope.wrapperMinHeight = (_.size(defaultMenu) + 2) * MENU_BUTTON_HEIGHT + 'px';
  $scope.menuHeight = _.size(defaultMenu) * MENU_BUTTON_HEIGHT + 'px';
  function checkFeature(entry) {
    if (entry.showIfFeature && featureToggleService.isDisabled(entry.showIfFeature) || entry.hideIfFeature && featureToggleService.isEnabled(entry.hideIfFeature)) {
      return false;
    }
    return true;
  }
  _.forEach(defaultMenu, function (entry, name) {
    if (checkFeature(entry)) {
      if (entry.headerFormat && featureToggleService.isDisabled('SPOS')) {
        entry.headerFormat = entry.headerFormat.replace(/\s*\(\$\{posName\}\)$/, '');
      }
      menu[name] = entry;
    }
  });
  var multipleRowSelectionSupportEnabled = _.filter(menu, function (value, key) {
    return value.isMultipleRowSelectionEnabled === true;
  }).length > 0;
  $scope.containsMenuItems = !_.isEmpty(menu);
  $scope.isMenuVisible = function (menuName) {
    var menuExists = !!menu[menuName];
    if (!menuExists) {
      return false;
    }
    var selectionValidationFunction = $scope.selectionValidationFunctions[menuName];
    var areMultipleRowsSelected = $scope.selectedRows.length > 1;
    var isSelectionValid;
    if (!areMultipleRowsSelected) {
      if (!!$scope.selectedRow) {
        isSelectionValid = selectionValidationFunction && selectionValidationFunction([$scope.selectedRow]);
        return !selectionValidationFunction || isSelectionValid;
      }
      return true;
    }
    var isMultipleRowSelectionDisabled = !menu[menuName].isMultipleRowSelectionEnabled;
    if (isMultipleRowSelectionDisabled) {
      return false;
    }
    isSelectionValid = selectionValidationFunction && selectionValidationFunction($scope.selectedRows);
    return !selectionValidationFunction || isSelectionValid;
  };
  $scope.getItemsCount = function (menuName) {
    var prop = $scope.getMenuProperty(menuName, 'counterProperty');
    if (prop && !_.isNil($scope.selectedRow)) {
      return $scope.selectedRow[prop];
    }
  };
  $scope.getInitialNotesCount = function (selectedRow) {
    var entityKey = menu.notes.key;
    commentsService.get(selectedRow, entityKey).then(function (comments) {
      $scope.commentsCount = comments ? comments.length : 0;
    });
  };
  $scope.getMenuProperty = function (menuName, propertyName) {
    return _.get(menu, [menuName, propertyName]);
  };
  $scope.openDrawer = function (mode) {
    $scope.isDrawerVisible = true;
    $scope.selectedMode = mode;
  };
  $scope.getDrawerContentConfig = function () {
    return menu[$scope.selectedMode];
  };
  $scope.hideDrawer = function () {
    $scope.isDrawerVisible = false;
    $scope.selectedMode = '';
  };
  function logDrawerOpened(mode) {
    $log.metric($scope.gridId + '.' + mode, 1, 'drawer');
  }
  $scope.toggleDrawer = function (mode) {
    if (_.includes(['service-share'], mode) && ($scope.isDirectForecast || $scope.isDemandDistributionIncremental)) {
      return;
    }
    if ($scope.selectedMode !== mode && $scope.isDrawerVisible) {
      $scope.hideDrawer();
      $scope.reOpenDrawerOnTransitionEnd(mode);
      logDrawerOpened(mode);
    } else if ($scope.isDrawerVisible) {
      $scope.hideDrawer();
    } else if (!$scope.isDrawerVisible) {
      $scope.openDrawer(mode);
      logDrawerOpened(mode);
    }
  };
  function hideDrawerAndClearModel() {
    $scope.hideDrawer();
    $scope.selectedRow = null;
    $scope.selectedRows = [];
    $scope.isPanelVisible = false;
  }
  $scope.getTooltipLabel = function (mode) {
    switch (mode) {
      case 'service-share':
        if ($scope.isDirectForecast) {
          return 'Direct Forecasting';
        } else if ($scope.isDemandDistributionIncremental) {
          return 'Fare Elasticity';
        } else {
          return 'Service Share';
        }
      default:
        return '';
    }
  };
  $scope.onRowSelectionChanged = function (event, selectedRows) {
    if (selectedRows.length === 1 && !_.isEqual($scope.selectedRow, selectedRows[0])) {
      $scope.selectedRow = selectedRows[0];
      $scope.selectedRows = [];
      $scope.isPanelVisible = true;
      $scope.isDirectForecast = directForecastingConfigurationService.isDirectForecastEnabled($scope.selectedRow);
      $scope.isDemandDistributionIncremental = configurationService.isDemandDistributionIncremental();
      if ($scope.reopenDrawerFlag) {
        $scope.reopenDrawerFlag = false;
        $scope.openDrawer($scope.reopenDrawerMode);
      }
      if (menu.notes) {
        $scope.getInitialNotesCount($scope.selectedRow);
      }
    } else if (selectedRows.length > 1) {
      $scope.selectedRow = null;
      if (multipleRowSelectionSupportEnabled) {
        $scope.selectedRows = selectedRows;
        $scope.isPanelVisible = true;
        $scope.hideDrawer();
      } else {
        hideDrawerAndClearModel();
      }
    } else if (selectedRows.length === 0) {
      hideDrawerAndClearModel();
    }
    $scope.containsMenuItems = !_.isEmpty(menu);
  };
  $scope.hideDrawerAndSetReopenFlag = function (event, mode) {
    $scope.reopenDrawerFlag = true;
    $scope.reopenDrawerMode = mode;
    $scope.hideDrawer();
  };
};
GridDrawerController.$inject = ['$scope', '$log', 'ConfigurationLoaderService', 'CommentsService', 'MappedRulesService', 'FeatureToggleService', 'DirectForecastingConfigurationService', 'ConfigurationService'];
module.exports = GridDrawerController;